import {useState} from "react";
import {FilterInterface} from "../../interfaces/catalog/FilterInterface";

interface CheckboxFilterGroupProps {
    filter: FilterInterface;
    selectedValues: string[];
    onToggle: (value: string) => void;
}

export default function CheckboxFilterGroup({filter, selectedValues, onToggle}: CheckboxFilterGroupProps) {
    const [showAll, setShowAll] = useState(false);
    const INITIAL_DISPLAY_COUNT = 10;

    const displayValues = showAll ? filter.possible_values : filter.possible_values.slice(0, INITIAL_DISPLAY_COUNT);
    const remainingCount = filter.possible_values.length - INITIAL_DISPLAY_COUNT;

    return (
        <>
            <div className="filter__item">
                <div className="filter__t-min d-flex justify-content-between align-items-start w-100">
                    <span className="filter__t-big fw-medium pb-3">{filter.type.name}</span>

                    {/*{remainingCount > 0 && (*/}
                    {/*    <div className={'float-end pointer text-orange text-nowrap'} onClick={() => setShowAll(!showAll)} >*/}
                    {/*        {showAll ? 'Скрыть' : `Еще (${remainingCount})`}*/}
                    {/*        </div>*/}
                    {/*)}*/}
                </div>
            </div>
            <div >
                {displayValues.map(value => (
                    <div key={value} className="filter__item">
                        <label className="filter__t-min form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedValues.includes(value)}
                                onChange={() => onToggle(value)}
                            />
                            <div className="form-check-icon"></div>
                            <span className="form-check-text">
                                <span>{value}</span>
                            </span>
                        </label>
                    </div>
                ))}
                {remainingCount > 0 && (
                    <div className={'pointer text-orange text-nowrap'} onClick={() => setShowAll(!showAll)} >
                        {showAll ? 'Скрыть' : `Показать еще (${remainingCount})`}
                    </div>
                )}
            </div>
        </>
    );
}